// extracted by mini-css-extract-plugin
module.exports = {"brightCoveContainer":"BrightCove_brightCoveContainer__2Hjo6","brightCoveVideo":"BrightCove_brightCoveVideo__WB1lc"};